import React, { createContext, useContext, useState, useCallback } from "react";

const BookingCountContext = createContext({ pending: 0, active: 0 });

export function BookingCountProvider({ children }) {
  const [counts, setCounts] = useState({ pending: 0, active: 0 });
  return (
    <BookingCountContext.Provider value={{ ...counts, setCounts: useCallback((c) => setCounts(c), []) }}>
      {children}
    </BookingCountContext.Provider>
  );
}

export const useBookingCounts = () => useContext(BookingCountContext);
